import { render, staticRenderFns } from "./headlinesDetailed.vue?vue&type=template&id=4c9f0842&scoped=true"
import script from "./headlinesDetailed.vue?vue&type=script&lang=js"
export * from "./headlinesDetailed.vue?vue&type=script&lang=js"
import style0 from "./headlinesDetailed.vue?vue&type=style&index=0&id=4c9f0842&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9f0842",
  null
  
)

export default component.exports